import RecommendPanelsButton from 'components/DisplayEnergy/PanelComponent/RecommendPanelsButton';
import { IrradianceToggle } from 'components/Irradiance/IrradianceToggle';
import PanelToggle from 'components/Irradiance/PanelToggle';
import { StripButoonWrap } from '../styles';
import { useSelector } from 'react-redux';
import { selectShowSettings } from 'store/selectors/settingsSelector';
import SettingsBtn from 'components/Settings/settingsBtn';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';
import Button from 'components/Basic/Button';

type Props = {
  editModeEnabled: boolean;
	showIrradiance: boolean;
};

function CalculatingSpinner() {
	return <div className="calculating-bar" />;
}

export default function SolarToolOptions(props: Props) {
	const { editModeEnabled, showIrradiance } = props;
	const showSettingIcon = useSelector(selectShowSettings);
	const isShadingAnalysisLoading = useSelector(selectIsRecomputing);

	const irradianceControl = isShadingAnalysisLoading
		? (
			<Button className="calculating-btn" disabled>
				<label>Calculating Irradiance</label>
				<CalculatingSpinner />
			</Button>
		)
		: <IrradianceToggle />;

	return (
		<>
			{showIrradiance &&
				<StripButoonWrap className='stripWrapperButtons'>
					<PanelToggle />
				</StripButoonWrap>
			}
			{/* Edit mode shows Irradiance first, ahead of Settings */}
			{editModeEnabled && irradianceControl}
			{showSettingIcon && <SettingsBtn />}
			{!editModeEnabled && <RecommendPanelsButton />}
			{!editModeEnabled && irradianceControl}
		</>
	);
}
